import {PaymentAbstract} from "./PaymentAbstract";
import PaymentConstant from "../../../view/constant/PaymentConstant";

export class Cash extends PaymentAbstract{
    code = PaymentConstant.CASH;
}


// WEBPACK FOOTER //
// ./src/service/payment/type/CashService.js